<template>
  <div class="match-list-item columns has-text-centered">
    <router-link :to="{name: 'User', params: { username: playerOne.User.username }}"
                 class="player column">
      {{ playerOne.User.username }}
    </router-link>
    <p class="column">{{ playerOne.gobPosition }}</p>
    <router-link :to="{ path: `/matchs/${match.id}` }"
                 class="column">
      <img :src="winnerImage" alt="" style="height: 40px;">
    </router-link>
    <p class="column">{{ playerTwo.gobPosition }}</p>
    <router-link :to="{name: 'User', params: { username: playerTwo.User.username }}"
                 class="player column">
      {{ playerTwo.User.username }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    match: {
      required: true,
      type: Object
    }
  },
  computed: {
    playerOne () {
      return this.match.MatchPlayers[0]
    },
    playerTwo () {
      return this.match.MatchPlayers[1]
    },
    winnerImage () {
      let src = '/static/images/'
      if (this.playerOne.winner === 1) {
        return src + 'winner-left.png'
      } else {
        return src + 'winner-right.png'
      }
    }
  }
}
</script>

<style scoped>
  .match-list-item {
    height: 60px;
    padding: 10px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MatchListItem.vue